import React from 'react';

import './StarRating.css';
import { getAppEnv } from '../../../config/env';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

type StarRating = {
  starValue: number;
  iconWidth: number;
  iconHeight: number;
  customStyle: any;
};
const StarRating = ({
  starValue,
  iconWidth,
  iconHeight,
  customStyle
}: StarRating) => {
  const renderDefaultIcon = () => {
    const temp: JSX.Element[] = [];
    for (let i = 0; i < 5; i++) {
      temp.push(
        <img
          className="lazyload"
          key={i}
          width={iconWidth}
          height={iconHeight}
          data-src={`${PUBLIC_URL}/static/public/ic_star_default.png`}
          alt={i.toString()}
        />
      );
    }
    return temp;
  };
  const renderActiveIcon = () => {
    const temp: JSX.Element[] = [];
    for (let i = 0; i < 5; i++) {
      temp.push(
        <img
          className="lazyload"
          key={i}
          width={iconWidth}
          height={iconHeight}
          data-src={`${PUBLIC_URL}/static/public/ic_star_selected.png`}
          alt={i.toString()}
        />
      );
    }
    return temp;
  };

  const calculatedWidth = iconWidth * starValue + 1 * starValue;

  return (
    <span className="sRating" style={customStyle ? customStyle : null}>
      <span
        className="sRating__row sRating__row--active"
        style={{ width: calculatedWidth }}
      >
        {renderActiveIcon()}
      </span>
      <span className="sRating__row">{renderDefaultIcon()}</span>
    </span>
  );
};

export default StarRating;
